import { FavoriteOccupation, OccupationCard } from '@cpd-app/generated';

export class FavoriteOccupationMapper {
  static toOccupationCard(
    favoriteOccupation: FavoriteOccupation
  ): OccupationCard {
    return {
      onetCode: favoriteOccupation.onetSocCode,
      title: favoriteOccupation.title,
      jobId: favoriteOccupation.jobId ?? 0,
      medianAnnualWage: favoriteOccupation.medianAnnualWage,
      medianHourlyWage: favoriteOccupation.medianHourlyWage,
      imageName: favoriteOccupation.imageName,
      isFavorite: favoriteOccupation.isFavorite,
      growthRateBand: favoriteOccupation.growthRateBand,
      skillsMatchQualityId: favoriteOccupation.skillsMatchQualityId,
      interestsMatchQualityId: favoriteOccupation.interestsMatchQualityId,
      valuesMatchQualityId: favoriteOccupation.valuesMatchQualityId,
      lifestyleMatchQualityId: favoriteOccupation.lifestyleMatchQualityId,
      typicalEducationLevelGroup:
        favoriteOccupation.preferredEdLevelDescription,
      // These fields are required by OccupationCard but not present in FavoriteOccupation
      userId: 0, // This will need to be set by the caller
      occupationCardCategoryType: null
    };
  }
}
